import React from 'react';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import BrandLogo from './BrandLogo';

const AppTopbar = ({
  brandHref,
  title,
  subtitle,
  navId = 'app-topbar-nav',
  className = 'app-topbar',
  pillText,
  pillClassName = '',
  userText,
  actions,
  onLogout,
}) => (
  <Navbar bg="dark" expand="lg" sticky="top" className={className}>
    <Container>
      <Navbar.Brand href={brandHref} className="fw-bold app-brand customer-brand app-brand-lockup">
        <BrandLogo />
        <span className="app-brand-copy">
          <strong>{title}</strong>
          {subtitle && <small>{subtitle}</small>}
        </span>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls={navId} />
      <Navbar.Collapse id={navId}>
        <Nav className="ms-auto align-items-center gap-2 gap-lg-3 topbar-actions">
          {pillText && (
            <span className={`topbar-sync-pill ${pillClassName}`.trim()}>
              <span className="live-dot" />
              {pillText}
            </span>
          )}
          {userText && <span className="navbar-text text-light me-3">{userText}</span>}
          {actions}
          {onLogout && (
            <Button variant="outline-light" onClick={onLogout}>
              Logout
            </Button>
          )}
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export default AppTopbar;
